@if (visible) {
  <div class="ram-overlay" (click)="$event.stopPropagation()">
    <div class="ram-backdrop"></div>
    <div class="ram-modal" role="dialog" aria-modal="true" aria-labelledby="ram-title">
      <!-- Gradient header band with title -->
      <div class="ram-header-band">
        <h2 class="ram-title" id="ram-title">Temporary Access Requested</h2>
      </div>
      <!-- White body -->
      <div class="ram-body-content">
        <!-- Agent row -->
        <div class="ram-agent-row">
          <div class="ram-avatar">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <div class="ram-agent-info">
            <p class="ram-agent-label">Routespring Support Agent</p>
            <p class="ram-agent-name">{{ agentName }}</p>
          </div>
        </div>
        <p class="ram-body">
          This agent is requesting temporary access to your account to assist you with your support request.
        </p>
        <div class="ram-info-block">
          <p class="ram-info-label">During this session, the agent will be able to:</p>
          <ul class="ram-list">
            <li>Modify your travel bookings and reservations</li>
            <li>Update your account preferences and settings</li>
            <li>Make changes to your profile information</li>
          </ul>
          <div class="ram-restrictions">
            <div class="ram-restriction-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
              </svg>
              Cannot see your screen or modify your password
            </div>
            <div class="ram-restriction-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              Access expires after {{ approvedSessionDurationFormatted }} or when the agent ends the session
            </div>
          </div>
        </div>
        <div class="ram-actions">
          <button class="ram-btn ram-btn-primary" [disabled]="responding" (click)="authorize()">Authorize Access</button>
          <button class="ram-btn ram-btn-secondary" [disabled]="responding" (click)="decline()">Decline Access</button>
        </div>
        <p class="ram-footer-note">
          You can end this session at any time by clicking the help icon.
        </p>
      </div>
    </div>
  </div>
}
